import { useEffect } from 'react';

export default function Meta({ title, description, isHome = false, pageTitle = '' }) {
  useEffect(() => {
    // Determine title
    let finalTitle = '';
    if (title) {
      finalTitle = title;
    } else if (isHome) {
      finalTitle = 'CHR. NIELSEN & SØN V/LEIF NIELSEN';
    } else {
      finalTitle = `${pageTitle || 'Underside'} – CHR. NIELSEN & SØN V/LEIF NIELSEN`;
    }

    document.title = finalTitle;

    // Determine description
    let finalDescription = description || '';
    if (!finalDescription) {
      if (isHome) {
        finalDescription = 'Professionel køletransport fra CHR. NIELSEN & SØN V/LEIF NIELSEN i Vejen. Vi tilbyder pålidelig transport med fokus på kvalitet, sikkerhed og levering til tiden.';
      } else {
        finalDescription = `${pageTitle || 'Underside'} hos CHR. NIELSEN & SØN V/LEIF NIELSEN. Kontakt os for pålidelig køletransport.`;
      }
    }

    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', finalDescription);

    // Update OG title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', finalTitle);

    // Update OG description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.setAttribute('content', finalDescription);
  }, [title, description, isHome, pageTitle]);

  return null;
}
